export type Locale = "en-US" | "en-CA";
export type Country = "US" | "CA";
export default Country;

/* v8 ignore next 3 */
export function detectCountry(country: string): Country {
	if (country.toUpperCase() === "CA") {
		return "CA";
	}

	return "US";
}

/**
 * @param {Locale} locale - Locale
 * @returns {Country} - Returns the country
 */
export function getCountryFromLocale(locale: Locale): Country {
	return locale?.slice(-2) as Country;
}
